import React, { useEffect, useState } from 'react';
import SaleRobo from 'components/molecules/sale_robo';
import { ProportionalSale } from 'services/actions/proportional_sale';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import { ApplicationState } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { getPanelProperties } from 'store/modules/panel_store/actions';
import tabId from 'services/tabId';

const RoboLanceSale = () => {
  const [dados, setDados] = useState<object | null>(null);
  const { panel, request: panelRequest } = useSelector<ApplicationState, PanelState>(
    (state) => state.session.panel,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!panelRequest?.loaded && !panelRequest?.loading) {
      dispatch(
        getPanelProperties(profile?.representant ? profile?.currentCompany[tabId()] : undefined),
      );
    }
  }, [dispatch, panelRequest?.loaded, panelRequest?.loading, profile]);

  useEffect(() => {
    if (panel?.validate_services?.robo) {
      window.location.href = '/facilitadores/robo';
    }
  }, [panel]);

  useEffect(() => {
    (async () => {
      const request = await ProportionalSale(10, [4]);
      request?.status === 200 && setDados(request?.data);
    })();
    document.title = 'Robô de Lances - ConLicitação';
  }, []);

  return (
    <div className="page-container pt-5">
      <SaleRobo dados={dados} />
    </div>
  );
};
export default RoboLanceSale;
